import React, { useState } from 'react';
import { Modal, Tooltip, Radio, Checkbox } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Row, Widget, Col, notification } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import { Visibility } from '@app/components/Visibility';
import { excluirDocumento } from '@app/api/ContabilidadeGeral';


interface Props {
    arquivoAutorizacaoId: string;
    updatePage: () => void;
}

const ModalExcluir = (props: Props) => {
    const { arquivoAutorizacaoId, updatePage } = props;
    const [exibirModal, setExibirModal] = useState(false);

    const handleSubmit = (values: any) => {
        excluirDocumento({ justificativa: values.justificativa, arquivoAutorizacaoId }).then(data => {
            if (data) {
                notification.success('Item removido com sucesso.');
                setExibirModal(false);
                updatePage();
            }
        });
    };

    return (
        <>
            <Tooltip title="Excluir Documento">
                <Button
                    onClick={() => setExibirModal(true)}
                    icon="commons-trash"
                    name='btnExcluir'
                />
            </Tooltip>
            <Visibility visible={exibirModal} >
                <Modal
                    title="Excluir Documento"
                    width='780px'
                    visible={exibirModal}
                    onCancel={() => {
                        setExibirModal(false);
                    }}
                    footer={null}>
                    <MasterDetailForm
                        onSubmit={handleSubmit}
                        key="formModalExcluir"
                        actions={[
                            <Button
                                type='link'
                                onClick={() => {
                                    setExibirModal(false);
                                }}>
                                Fechar
                            </Button>,
                            <FormSubmitButton
                                noIcon
                                type="primary"
                                disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
                                <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>
                        ]}>
                        <FormTextArea
                            name="justificativa"
                            span={12}
                            rows={4}
                            maxLength={2000}
                        />
                    </MasterDetailForm>

                </Modal>
            </Visibility>
        </>
    );
};

export default ModalExcluir;